const Investment_message =
  "The Investment Section provides you with a list of cryptocurrencies and blockchain projects we are currently recommending and their updside and downside financial projections, you can then choose to invest in any.";

const Lending_message =
  "Lending gives you an opportunity to loan out funds to verified smart-contracts at a specific interest rate within a stated time frame.";
const Saving_message =
  "On Kabura, people are exploring the act of saving in different ways, especially those typical to Africans. Kabura leverages smart contracts to bind rules and presents you with each existing group from which you can choose.";
const Borrow_message =
  "When in need of funds, Kabura lets you borrow from another member at an interest rate for a given time frame.";

export { Investment_message, Lending_message, Saving_message, Borrow_message };
